import { render, staticRenderFns } from "./PageCard.vue?vue&type=template&id=02dd91e0&scoped=true&"
import script from "./PageCard.vue?vue&type=script&lang=ts&"
export * from "./PageCard.vue?vue&type=script&lang=ts&"
import style0 from "./PageCard.vue?vue&type=style&index=0&id=02dd91e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd91e0",
  null
  
)

export default component.exports